import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=54327e8c&scoped=true"
import script from "./Admins.vue?vue&type=script&lang=js"
export * from "./Admins.vue?vue&type=script&lang=js"
import style0 from "./Admins.vue?vue&type=style&index=0&id=54327e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54327e8c",
  null
  
)

export default component.exports